import { render } from "./checkPassword.vue?vue&type=template&id=af4b6210&scoped=true"
import script from "./checkPassword.vue?vue&type=script&lang=js"
export * from "./checkPassword.vue?vue&type=script&lang=js"

import "@/resources/css/settings.scss?vue&type=style&index=0&id=af4b6210&lang=scss&scoped=true&external"
import "./checkPassword.vue?vue&type=style&index=1&id=af4b6210&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4b6210"]])

export default __exports__